import { LoaderFunction } from "react-router-dom";
import { titrationApi } from "src/api/services/titrationApi";
import { store } from "src/api/store";
import { ORDER, PRODUCT } from "src/constants/searchParams";

export const titrationsLoader: LoaderFunction = ({ request }) => {
  const searchParams = new URL(request.url).searchParams;

  const product =
    searchParams.get(PRODUCT) != null ? searchParams.get(PRODUCT) : "";
  const order = searchParams.get(ORDER) != null ? searchParams.get(ORDER) : "";

  return store
    .dispatch(
      titrationApi.endpoints.getTitrations.initiate({
        ascending: order === "asc" ? true : false,
        product: product ?? undefined,
      }),
    )
    .unwrap();
};
